

export default {
  created: function() {
    const routes = require("../routing/routes").default;
    this.MainRoutes = routes.filter((item) => {
      if (item.IsMainPath) {
        return item;
      }
    });
    this.AllRoutes = routes;
  },

  data: function() {
    return {
      MainRoutes: null,
      AllRoutes: null,
    };
  },
  methods: {
    GoNext: function() {
      var index = this.GetCurrentRouteIndex() + 1;
      var route = this.AllRoutes[index];
      this.$router.push(route.path);
    },

    GoBack: function() {
      var index = this.GetCurrentRouteIndex() - 1;
      var route = this.AllRoutes[index];
      this.$router.push(route.path);
    },

    GetCurrentRouteIndex: function() {
      var currentRoute = this.$route.path;
      return this.AllRoutes.map((item) => item.path).indexOf(currentRoute);
    },

    GetCurrentRoute: function() {
      let currentIndex = this.GetCurrentRouteIndex();
      return this.AllRoutes[currentIndex];
    },

    GetRouteByPath: function(path) {
      let index = this.AllRoutes.map((item) => item.path).indexOf(path);
      return this.AllRoutes[index];
    },
    IsCurrentIsMainPath: function() {
      let currentIndex = this.GetCurrentRouteIndex();
      let currentPath = this.AllRoutes[currentIndex];
      if (!currentPath) return false;
      else return !!currentPath.IsMainPath;
    },
  },
};
